import { Button, Paper, Typography } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import { MaterialTableProps } from "material-table";
import React, { FunctionComponent } from "react";
import styles from './VendorAuthCredentials.Styles';
import MaterialTable from "../../generic-components/material-table/MaterialTable.Component";
import StateEntity from "../../../entities/State.Entity";
import AuthenticationTypeEntity from "../../../entities/AuthenticationType.Entity";
import VendorAuthCredentialEntity from "../../../entities/VendorAuthCredential.Entity";
import { AddVendorAuthCredential } from "../add-vendor-auth-credential/AddVendorAuthCredential.Component";
import VendorAuthCredentialDataModel from "../../../data-models/VendorAuthCredential.DataModel";
import { Confirm } from "../../generic-components/confirm/Confirm.Component";

interface VendorAuthCredentialsProps{
    vendorAuthCredentials: Array<VendorAuthCredentialDataModel>;
    newVendorAuthCredential: VendorAuthCredentialEntity,
    handleVendorAuthCredentialEdit: (newVendor: VendorAuthCredentialEntity) => void;
    createVendorAuthCredential: () => void;
    deleteVendorAuthCredential: (authCredentialId: number) => void;
    states: Array<StateEntity>;
    authenticationTypes: Array<AuthenticationTypeEntity>;
    vendorId: number;
    userSecurityRules: string[];
}

const AddAuthCredentialButton = ({ onClick, classes, ...props }) => (
    <Button {...props} className={classes.button} onClick={onClick}>
        Add Auth Credential
    </Button>
);

const DeleteAuthCredentialIcon = () => <DeleteIcon style={{ fill: 'rgba(0,0,0,0.54)' }} />;
const DisabledDeleteAuthCredentialIcon = () => <DeleteIcon style={{ fill: 'rgba(0,0,0,0.26)', cursor: 'default' }} />;

export const VendorAuthCredentials: FunctionComponent<VendorAuthCredentialsProps> = (props) => {

    const classes = styles();
    
    const [filter, setFilter] = React.useState<boolean>(false);
    const [showAddVendorAuthCredential, setShowAddVendorAuthCredential] = React.useState<boolean>(false);
    const [showConfirmDelete, setShowConfirmDelete] = React.useState<boolean>(false);
    const [selectedAuthCredentialId, setSelectedAuthCredentialId] = React.useState<number>(null);

    const hasDeletePermission = props.userSecurityRules?.includes('delete:VENDOR.VENDOR_LIST') || props.userSecurityRules?.includes('delete:VENDOR');

    const clientsTableProps: MaterialTableProps<VendorAuthCredentialDataModel> = {
        columns: [
            {
                title: 'Auth Type',
                field: 'authenticationType',
            },
            {
                title: 'Auth Key Type',
                field: 'authKeyType',
            },
            {
                title: 'Auth Key',
                field: 'authKey',
            },
            {
                title: 'Auth Value Secret ID',
                field: 'authValueSecretID'
            },
            {
                title: 'Token EndPoint',
                field: 'tokenEndpoint'
            },
            {
                title: 'Scope',
                field: 'scope',
            },
            {
                title: 'Resource',
                field: 'resource',
            },
            {
                title: 'CommunicationType',
                field: 'communicationType',
            }
        ],
        data: props.vendorAuthCredentials ? props.vendorAuthCredentials : [],
        options: {
            filtering: filter,
            showTitle: false,
            paging: props.vendorAuthCredentials ? props.vendorAuthCredentials.length > 10 : false,
            toolbar: true,
            actionsColumnIndex: -1,
        },
        style:{
            paddingLeft: '35px',
            paddingRight: '35px',
        },
        actions:[            
            {
                icon: (iconProps) => (
                    <AddAuthCredentialButton
                        {...iconProps}
                        classes={classes}
                        onClick={() => setShowAddVendorAuthCredential(true)}
                    />
                ),                
                tooltip: 'Add Auth Credential',
                position: 'toolbar',
                onClick: () => setShowAddVendorAuthCredential(true), // Added onClick property
            },
            (rowData) => {
                if (hasDeletePermission) {
                    return {
                        icon: () => <DeleteAuthCredentialIcon />,
                        tooltip: "Delete Auth Credential",
                        position: 'row',
                        onClick: (event, rowData) => {
                            if (Array.isArray(rowData)) return;
                            setSelectedAuthCredentialId(rowData.authCredentialId);
                            setShowConfirmDelete(true);
                        },
                    };
                } else {
                    return {
                        icon: () => <DisabledDeleteAuthCredentialIcon />,
                        tooltip: "Unable to delete",
                        position: 'row',
                        onClick: () => {},
                    };
                }
            },
        ],        
        title: 'Vendor Auth Credential List'
    }

    return (
        <>
            <Paper className={classes.paper}>
                {showAddVendorAuthCredential ? 
                <AddVendorAuthCredential
                    newVendorAuthCredential={props.newVendorAuthCredential}
                    handleVendorAuthCredentialEdit={props.handleVendorAuthCredentialEdit}
                    createVendorAuthCredential={props.createVendorAuthCredential}
                    states={props.states}
                    authenticationTypes={props.authenticationTypes}
                    cancel={() => setShowAddVendorAuthCredential(false)}
                    vendorId={props.vendorId}
                />
                    : 
                        <MaterialTable tableProps={clientsTableProps} /> 
                }
            </Paper>
            <Confirm
                onAction={() => {                    
                    props.deleteVendorAuthCredential(selectedAuthCredentialId);
                    setShowConfirmDelete(false);
                }}
                title="Delete Auth Credential"
                onToggleConfirm={() => {
                    setShowConfirmDelete(false);
                }}
                openDialog={showConfirmDelete}
                okText="Delete"
                noText="Cancel"
                messageText="You are about to delete an Auth Credential, do you want to proceed?"
            />
        </>
    )        
}